<template>
  <div class="billing-switch">
    <ul class="billing-switch-list">
      <li class="billing-switch-item monthly">
        <div class="billing-switch-container">
          <input id="monthly" type="radio" v-model="billingswitch" @change="$emit('selected-monthly', false)" class="billing-switch-input" value="monthly"> 
          <label for="monthly" class="billing-switch-label">
            <div class="billing-switch-label-wrap">
              <span class="billing-switch-label-text">{{ $gettext('Bill monthly') }}</span> 
            </div>
            <div class="billing-switch-label-sub">
              <span>€{{ getProductByType('premium').cost }}/{{ $gettext('month') }}</span>
            </div>
          </label>
        </div>
      </li>
      <li class="billing-switch-item yearly">
        <div class="billing-switch-container">
          <input id="yearly" type="radio" v-model="billingswitch" @change="$emit('selected-yearly', false)" class="billing-switch-input" value="yearly"> 
          <label for="yearly" class="billing-switch-label">
            <div class="billing-switch-label-wrap">
              <span class="billing-switch-label-text">{{ $gettext('Bill Yearly') }}</span>
              <span class="billing-switch-savings">{{ activeDiscount.triggerText }}</span>
            </div>
            <div class="billing-switch-label-sub">
              <span>{{ activeDiscount.short_line_description }}</span>
            </div>
          </label>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>

import { mapGetters } from "vuex";

export default {
  name: 'GekkoBillingSwitch',
  props: {
    initialYearly: {
      type: Boolean,
      default: false
    },
    activeDiscount: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      billingswitch: 'monthly' // monthly by default
    }
  },
  computed: {
    ...mapGetters({ 
      getProductByType: 'subscriptionStore/getProductByType'
    }),
  },
  created () {
    if (this.initialYearly) this.billingswitch = 'yearly';
  },
}
</script>

<style lang="scss" scoped>
  .billing-switch {
    .billing-switch-list {
      display: flex;
      flex-flow: column wrap;
      list-style: none;
      padding: 0;
      margin: 0;
      gap: 1rem;
      .billing-switch-item {
        position: relative;
        // flex: 1 1;
        width: calc(50% - 0.5rem);
        margin: 0;
        .billing-switch-container {
          width: 100%;
          height: 100%;

          input[type='radio'] {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 20px;
            height: 20px;
            transition: box-shadow 200ms ease, background 200ms ease, border 200ms ease, -webkit-box-shadow 200ms ease;
            border: 1px solid #dbdbde;
            outline: none;
            background: #fff;
            appearance: none;
          }
          input:checked[type='radio'] {
            border-color: $colorBrand;
            background-color: $colorBrand;
          }

          input[type='radio']:checked:after {
            content: '';
            width: 10px;
            height: 10px;
            border-radius: 50%;
            background: #fff;
          }

          .billing-switch-input {
            position: absolute;
            top: 1.5rem;
            right: 12px;
            margin: 0;
            box-sizing: border-box;
            padding: 0;
            overflow: visible;
            border-radius: 50%;
          }

          .billing-switch-label {
            font-size: 1rem;
            line-height: 22px;
            display: block;
            margin-bottom: 10px;
            color: #0d0c22;

            box-sizing: border-box;
            width: 100%;
            height: 100%;
            padding: 20px 2.25rem 20px 1.5rem;
            border-radius: $radiusMd;
            background: white;
            outline: 1px solid $colorBorderDash;

            margin: 0; 
            cursor: pointer;

            .billing-switch-label-wrap {
              margin-bottom: 8px;
              display: flex;
              align-items: center;
              .billing-switch-label-text {
                font-size: 17px;
                margin-right: 8px;
                white-space: nowrap;
              }
            }

            .billing-switch-label-sub {
              opacity: 0.6;
              font-size: 1rem;
              line-height: 20px;
            }

            .billing-switch-savings {
              margin-left: 4px;
              padding: 4px;
              border-radius: 16px;
              background: #4bb7bf;
              color: #fff;
              font-size: 12px;
              line-height: 12px;
              white-space: nowrap;
            }
          }

          .billing-switch-input:checked + .billing-switch-label {
            outline: 2px solid $colorBrand;
          }
        }
      }
    }

    @media (min-width: 768px) {
      .billing-switch-list {
        flex-direction: row;
      }
    }
  }

</style>